import performanceNow from 'performance-now';

/**
 * The minimum FPS we want to target.
 * @type {Number}
 */
const MIN_FPS = 10;
/**
 * Continue after waiting the given amount of ms even if it impacts FPS (guard
 * against a few rare conditions that can delay execution indefinitely).
 * @type {Number}
 */
const MAX_WAIT_TIME = 5000;


const MAX_LAST_FRAME_AGE = 1000 / MIN_FPS;

// Strictly speaking, this is actually the TS of the last animation frame
// we happen to know ran - we don't wan to turn on the JS engine on EVERY frame
// if we can avoid it. The only drawback of this is that the first
// `await animationFrame()` call will always delay a frame even if it didn't
// have to, but that's probably ok.
let lastAnimationFrameRanAt = 0;

/**
 * Await this function inside expensive javascript functions  to allow
 * animation to run at least one frame before continuing.
 *
 * @return {Promise} An (empty) Promise that resolves either immediately (if
 * FPS is within the conifigured `MIN_FPS`) or just before the SECOND animation
 * frame from now otherwise.
 */
function animationFrame () {
  let waitingSince = performanceNow();
  return new Promise(resolve => {
    function continueIfFPsAllows () {
      let now = performanceNow();
      let lastFrameAge = now - lastAnimationFrameRanAt;
      let waitTime = now - waitingSince;
      if (lastFrameAge < MAX_LAST_FRAME_AGE || waitTime > MAX_WAIT_TIME) {
        resolve();
      } else {
        window.requestAnimationFrame(ts => {
          lastAnimationFrameRanAt = ts;
          window.requestAnimationFrame(() => {
            continueIfFPsAllows();
          });
        });
      }
    }
    continueIfFPsAllows();
  });
}

export default typeof window === 'object' && typeof window.requestAnimationFrame === 'function' ? animationFrame : function () {};



// WEBPACK FOOTER //
// ./lib/rlink-await-animation-frame.js